export const REGISTER_REFERRER = 'src/ReferrerSignUp/REGISTER_REFERRER';
export const REGISTER_REFERRER_SUCCESS = 'src/ReferrerSignUp/REGISTER_REFERRER_SUCCESS';
export const REGISTER_REFERRER_FAILURE = 'src/ReferrerSignUp/REGISTER_REFERRER_FAILURE';
